import * as React from "react";
const SvgFastForward20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 16,
        fill: "black",
        viewBox: "0 0 20 16"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M9 6.75 0 0v16l9-6.75V16l10.667-8L9 0v6.75ZM7.333 8 2 12V4l5.333 4Zm9 0L11 12V4l5.333 4Z",
      clipRule: "evenodd"
    })
  );
export default SvgFastForward20Px;
